import { FC, ReactNode } from "react";

type Props = {
  icon: ReactNode;
  title: string;
  text: string;
  button?: ReactNode;
};

export const NotificationBanner: FC<Props> = ({
  icon,
  title,
  text,
  button
}) => {
  return (
    <div className="mb-6 flex items-center justify-between rounded-lg bg-background-1000 px-6 py-5 border border-alpha-100 shadow-xs">
      <div className="flex-1 flex items-center gap-6">
        {icon}
        <div className="h-16 w-px bg-alpha-40" />
        <div className="flex flex-col flex-1">
          <h3 className="mb-2 text-base font-bold text-content-1000">
            {title}
          </h3>
          <p className="text-sm text-content-400">{text}</p>
        </div>
      </div>
      {button ? button : null}
    </div>
  );
};
